import { css, CSSObject } from "styled-components";

export const mediaQuery = {
  tablet: "width <= 768px",
};

export const tablet = (
  first: CSSObject | TemplateStringsArray,
  ...interpolations: (CSSObject | string)[]
) => css`
  @media (max-width: 768px) {
    ${css(first, ...interpolations)}
  }
`;

export const smallPc = (
  first: CSSObject | TemplateStringsArray,
  ...interpolations: (CSSObject | string)[]
) => css`
  @media (max-width: 1279px) {
    ${css(first, ...interpolations)}
  }
`;

export const pc = (
  first: CSSObject | TemplateStringsArray,
  ...interpolations: (CSSObject | string)[]
) => css`
  @media (min-width: 769px) {
    ${css(first, ...interpolations)}
  }
`;
